import Icon from '@components/common/assets';
import Tooltip from '@components/common/tooltip';

import Colors from '@domain/constant/colors';
import classnames from 'classnames/bind';
import styles from './index.module.scss';
const cx = classnames.bind(styles);

interface IResponseRateTextProps {
  responseRate?: number;
  className?: string;
}

const ResponseRateText = ({ responseRate = 0, className }: IResponseRateTextProps) => {
  return (
    <span className={cx('responseTextWrap', className)}>
      <p className={cx('responseRateText')}>
        제안 응답률 <span className={cx('responseRate')}>{responseRate}%</span>
      </p>
      <Tooltip
        label={<Icon name="informationLight" width={22} height={22} fill={Colors.C_COOL_GRAY_70} />}
        content="응답률이 50% 이상인 지원자는 더 많은 입사제안을 받고 있어요."
        placement="top-right"
        theme="gray"
        top={-60}
        left={-340}
        iconLeft={346}
      />
    </span>
  );
};

export default ResponseRateText;
